import { useCallback } from "react";

import { useFormActions, useFieldValue } from "2g-form/hooks";

import { FILES } from "b2b/api";
import { useDownloadFile } from "b2b/api/hooks";

import useDelete from "./useDelete";

const EMPTY_ARRAY = [];

export default function useFileChooser({ path, hasDownload, hasDelete }) {
  const value = useFieldValue(path);
  const files = value || EMPTY_ARRAY;
  const actions = useFormActions();
  const onDeleteServer = useDelete();
  const downloadFile = useDownloadFile();

  const onDelete = useCallback(
    file => {
      let newValue = files?.filter(f => file.name !== f.name);
      newValue = newValue.length > 0 ? newValue : undefined;
      if (file?.key) {
        onDeleteServer(file, () => {
          actions.setValue(path, newValue);
        });
      } else {
        actions.setValue(path, newValue);
      }
    },
    [files]
  );

  const onDownload = useCallback(file => {
    file.key && downloadFile(FILES.provozniInformace(file.key));
  }, []);

  const onChangeInternal = useCallback(
    newValue => {
      actions.setValue(path, newValue);
    },
    [files, onDelete]
  );

  return {
    onChange: onChangeInternal,
    value,
    onDelete: hasDelete ? onDelete : undefined,
    onDownload: hasDownload ? onDownload : undefined
  };
}
